import { Component, DoCheck, ElementRef, EventEmitter, HostListener, Input, IterableDiffers, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SelectValue } from '../../core/model/template-field';

@Component({
  selector: 'app-custom-select',
  templateUrl: './custom-select.component.html',
  styleUrls: ['./custom-select.component.css']
})
export class CustomSelectComponent implements OnInit, DoCheck {
  @ViewChild('uldropdown') uldropdown: ElementRef;
  @ViewChild('divDropdow') divDropdow: ElementRef;

  _inputData: SelectValue[] = [];

  @Input()
  set inputData(values: SelectValue[]) {
    this.verifyInputData(values);
    this._inputData = values;
    this.updateTitle();
  }
  get inputData(): SelectValue[] {
    this.inputDataSelected = this._inputData.find(input => input.valor.toLowerCase().startsWith(this.filterKeyDown));
    return this._inputData.sort((left, right): number => {
      if (left[this.descriptionField] < right[this.descriptionField]) { return -1; }
      if (left[this.descriptionField] > right[this.descriptionField]) { return 1; }
      return 0;
    });
  }
  @Input() valueField: string;
  @Input() descriptionField: string;
  @Input() defaultTitle: string;
  @Input() set hasResetValues(hasReset: boolean) {
    if (hasReset) {
      this.selectedValues = [];
      this.updateTitle();
      this.resetValues.emit(true);
    }
  }
  @Output() optionSelected = new EventEmitter<any>();
  @Output() resetValues = new EventEmitter<boolean>();

  @Output() selectedValuesChange = new EventEmitter();
  @Input()
  get selectedValues() {
    return this._selectedValues;
  }
  set selectedValues(values: any[]) {
    this._selectedValues = values || [];
    this.selectedValuesChange.emit(this._selectedValues);
    this.updateTitle();
  }

  private _selectedValues: any[] = [];
  isClicked = false;
  title: string;
  singleSelectedTitle: string;
  multipleSelectedTitle: string;
  differ: any;
  isUlClicked = false;
  @Input() isVisible = true;

  private timeOutInput: any;
  filterKeyDown: string;
  inputDataSelected: SelectValue;
  private hasInitializeFilterKeyDown = true;

  constructor(differs: IterableDiffers, private eRef: ElementRef, translateService: TranslateService,
    private elem: ElementRef) {
    this.differ = differs.find([]).create(null);
    this.defaultTitle = translateService.instant('customSelect.anyValueSelected');
    this.singleSelectedTitle = translateService.instant('customSelect.elementSelected');
    this.multipleSelectedTitle = translateService.instant('customSelect.elementsSelected');
  }

  ngOnInit() {
    this.title = this.defaultTitle;
  }

  ngDoCheck() {
    if (this.differ.diff(this.inputData)) {
      // Ha habido una modificación en el array inputData. Verificamos ausencia de duplicados
      this.verifyInputData(this.inputData);
      // Verificamos la compatibilidad de las opciones seleccionadas y las nuevas opciones disponibles
      this.selectedValues = this.selectedValues.filter(value => this.inputData.find(value));
      this.updateTitle();
      this.optionSelected.emit(this.inputData.filter(option => this.selectedValues.indexOf(option[this.valueField]) >= 0));
    }
  }

  verifyInputData(values: any[]) {
    if (values && this.valueField) {
      values = values.sort();
      const auxArray = [];
      values.forEach(value => {
        if (auxArray.indexOf(value[this.valueField]) >= 0) {
          throw new Error('Invalid Options Exception');
        } else {
          auxArray.push(value[this.valueField]);
        }
      });
    }
  }

  updateTitle() {
    switch (this.selectedValues.length) {
      case 0:
        this.title = this.defaultTitle;
        break;
      case 1:
        this.title = this.singleSelectedTitle.replace('{selectedCount}', '' + this.selectedValues.length);
        break;
      default:
        this.title = this.multipleSelectedTitle.replace('{selectedCount}', '' + this.selectedValues.length);
        break;
    }

  }

  selectOption(option: any): boolean {
    // const toReturn = this.selectedValues.indexOf(value) < 0;
    const toReturn = !this.selectedValues.find(rec => rec[this.valueField] === option[this.valueField]);
    if (toReturn) {
      this.selectedValues = this.selectedValues.concat(option);
    } else {
      this.selectedValues = this.selectedValues.filter(idAux => idAux !== option);
    }
    this.updateTitle();
    // this.optionSelected.emit(this.inputData.filter(opt => this.selectedValues.find(rec => rec[this.valueField] === opt[this.valueField])));
    this.optionSelected.emit(this.selectedValues);
    this.inputDataSelected = undefined;
    this.filterKeyDown = undefined;
    this.modifyUlScroll();
    return toReturn;
  }

  isSelected(option: any): boolean {
    return this.selectedValues.find(rec => rec[this.valueField] === option[this.valueField]);
  }

  click(e) {
    const isEnterKey = e.clientX == 0 && e.clientY == 0;
    if (isEnterKey) {
      return;
    }
    this.isClicked = !this.isClicked;
    this.setVisibilityUl();
    if (this.isClicked) {
      document.body.appendChild(this.uldropdown.nativeElement);
      this.absolutePosition(this.uldropdown.nativeElement, this.divDropdow.nativeElement);
    } else {
      document.body.removeChild(this.uldropdown.nativeElement);
    }
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      if (this.isClicked && !this.isUlClicked) {
        document.body.removeChild(this.uldropdown.nativeElement);
        this.isClicked = false;
      } else {
        this.isUlClicked = false;
      }
    }
  }

  public close() {
    if (this.isClicked) {
      document.body.removeChild(this.uldropdown.nativeElement);
      this.isClicked = false;
     }
  }

  private setVisibilityUl(): any {
    this.uldropdown.nativeElement.style.display = this.isClicked ? 'block' : 'none';
  }

  private absolutePosition(element: any, target: any): void {
    const elementDimensions = element.offsetParent ? { width: element.offsetWidth, height: element.offsetHeight } : this.getHiddenElementDimensions(element);
    const elementOuterHeight = elementDimensions.height;
    const elementOuterWidth = elementDimensions.width;
    const targetOuterHeight = target.offsetHeight;
    const targetOuterWidth = target.offsetWidth;
    const targetOffset = target.getBoundingClientRect();
    const windowScrollTop = this.getWindowScrollTop();
    const windowScrollLeft = this.getWindowScrollLeft();
    const viewport = this.getViewport();
    let top, left;

    if (targetOffset.top + targetOuterHeight + elementOuterHeight > viewport.height) {
      top = targetOffset.top + windowScrollTop - elementOuterHeight;
      if (top < 0) {
        top = 0 + windowScrollTop;
      }
    } else {
      top = targetOuterHeight + targetOffset.top + windowScrollTop;
    }

    if (targetOffset.left + targetOuterWidth + elementOuterWidth > viewport.width) {
      left = Math.max(0, targetOffset.left + windowScrollLeft + targetOuterWidth - elementOuterWidth);
    } else {
      left = targetOffset.left + windowScrollLeft;
    }

    element.style.top = top + 'px';
    element.style.left = left + 'px';
  }

  private getHiddenElementDimensions(element: any): any {
    const dimensions: any = {};
    element.style.visibility = 'hidden';
    element.style.display = 'block';
    dimensions.width = element.offsetWidth;
    dimensions.height = element.offsetHeight;
    element.style.display = 'none';
    element.style.visibility = 'visible';

    return dimensions;
  }

  private getWindowScrollTop(): number {
    const doc = document.documentElement;
    return (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
  }

  private getWindowScrollLeft(): number {
    const doc = document.documentElement;
    return (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
  }

  private getViewport(): any {
    const win = window,
      d = document,
      e = d.documentElement,
      g = d.getElementsByTagName('body')[0],
      w = win.innerWidth || e.clientWidth || g.clientWidth,
      h = win.innerHeight || e.clientHeight || g.clientHeight;

    return { width: w, height: h };
  }

  handleKeyboardEvent(keydownEvent) {
    if ((this.isClicked || this.isUlClicked) && this.isValidKeyCode(keydownEvent.keyCode)) {
      if (keydownEvent.keyCode == 13 && this.inputDataSelected) {
        this.selectOption(this.inputDataSelected);
      } else if (keydownEvent.keyCode == 8) {
        this.filterKeyDown = (this.filterKeyDown || '').length > 0 ? this.filterKeyDown.substr(0, this.filterKeyDown.length - 1) : this.filterKeyDown;
      } else {
        this.manageKeyboardEvent(keydownEvent);
       }
    }
  }
  private manageKeyboardEvent(keydownEvent: any) {
    clearTimeout(this.timeOutInput);
    const letter = String.fromCharCode(keydownEvent.keyCode).toLowerCase();
    this.filterKeyDown = this.hasInitializeFilterKeyDown ? letter
      : (this.filterKeyDown || '') + letter;
    this.hasInitializeFilterKeyDown = false;
    this.modifyUlScroll();
    setTimeout(() => {
      this.modifyUlScroll();
    }, 50);
    this.timeOutInput = setTimeout(() => {
      this.hasInitializeFilterKeyDown = true;
      if (!this.inputDataSelected) {
        this.modifyUlScroll();
      }
    }, 1000);
  }
  private isValidKeyCode(keycode: any) {
    const isValid =
      (keycode > 47 && keycode < 58) || // number keys
      keycode == 32 || keycode == 13 || // spacebar & return key(s)
      keycode == 8 || // backspace key
      (keycode > 64 && keycode < 91); // letter keys
    return isValid;
  }

  private modifyUlScroll() {
    if (this.isClicked) {
      const scrollTop = this.inputDataSelected ? (<any>document.querySelectorAll('.dropdown-selected')[0]).offsetTop : 0;
      this.uldropdown.nativeElement.scrollTop = scrollTop;
    }
   }

}
